import React from 'react';
import {Box} from '@mui/material';
import colors from 'shared/aptitude/colors';
import InfoIcon from 'shared/components/info-icon';
import FileUploadForm from 'src/components/FileUploadForm';
import {UploadDetails} from 'src/services/UploadTypeService';
import Title from 'src/components/AccountSettings/Title';
import useBrandName from 'src/hooks/use-brand-name';
import useFeatureFlags from 'src/hooks/useFeatureFlags';
const sampleCSVLink = 'https://resources.raise.me/data/spot_award_template.csv';
const sampleCSVLeadGenLink =
  'https://resources.raise.me/data/spot_award_template_lead_generation.csv';

const Disclaimer = () => {
  const brandName = useBrandName();
  return (
    <Box p={3} my={3} bgcolor={colors.m50} borderRadius="4px">
      <InfoIcon /> The provision of this data is a standard practice amongst all {brandName}{' '}
      colleges, is covered in terms of {brandName}’s partnership agreement, and is FERPA compliant
      per our Master Services Addendum.
    </Box>
  );
};

const uploadDetails: UploadDetails = {
  maxFileSize: 1024 * 1024 * 10,
  allowedFileTypes: ['all'],
};

const SpotAwardFileUploadForm = () => {
  const leadGenerationLogoFlag = useFeatureFlags(['leadGenerationLogoFlag']);

  return (
    <FileUploadForm
      fileDescription="Upload students to award"
      uploadType="spot_award"
      Disclaimer={Disclaimer}
      uploadDetails={uploadDetails}
    >
      <Title>Spot Award File Upload</Title>
      <Box pt={1} pb={2}>
        Spot awards equip you with an additional tool to engage and convert prospective students in
        your funnel. With this feature, you can easily upload a list of students to update their
        award with additional dollars. We will email the student to inform them of this award.
      </Box>
      <Box pb={2}>
        Please note, that this award value is in <strong>addition</strong> to the student&apos;s
        submitted micro-scholarship earnings and will increase their 4 year total. For example, if a
        student was submitted for $10,000 and their award amount in this upload is $500, their new
        4-year total will be $10,500.
      </Box>
      <Box pb={2}>
        The file must include the following columns:
        <ul>
          <li>first_name</li>
          <li>last_name</li>
          <li>{leadGenerationLogoFlag ? 'lead_generation_code' : 'raisecode'}</li>
          <li>email</li>
          <li>award_amount</li>
          <li>award_name</li>
        </ul>
      </Box>
      <Box>
        Download a{' '}
        <a href={leadGenerationLogoFlag ? sampleCSVLeadGenLink : sampleCSVLink}>
          sample CSV template
        </a>{' '}
        to see an example of the requested format and required fields. Any questions? Email{' '}
        <a href="mailto:support@campuslogic.com">support@campuslogic.com</a>
      </Box>
    </FileUploadForm>
  );
};

export default SpotAwardFileUploadForm;
